import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  selectCinema,
  selectDate,
  selectView, getCurrentTime,
  getWeeksAndCinemas, getWeekDetails,
  closeModal,
  openModal, getFestival,
} from 'actions/appActions';
import MobileCinemaFilter from 'components/MobileFilters/MobileCinemaFilter';
import MobileCinemaFilterModal from 'components/MobileFilters/MobileCinemaFilterModal';
import MobileDateFilterModal from 'components/MobileFilters/MobileDateFilterModal';
import MobileDateFilter from 'components/MobileFilters/MobileDateFilter';
import ViewSelector from 'components/ViewSelector/ViewSelector';
import MovieTable from 'components/MovieTable/MovieTable';
import MobileFilmTiles from 'components/MobileFilmTiles/MobileFilmTiles';
import FilmTiles from 'components/FilmTiles/FilmTiles';
import './mobile-cinema-filter.scss';


class MobileAppFilter extends React.Component {
  state = {
    cinemaModalOpen: false,
    dateModalOpen: false,
    initialised: false,
  }

  componentDidMount() {
    this.props.dispatchGetCurrentTime();
    this.props.dispatchGetWeeksAndCinemas();
    this.props.dispatchGetFestival(this.props.festival);
  }

  handleCinemaFilterOpen = () => {
    this.setState({
      cinemaModalOpen: true,
    });
    document.body.style.overflow = 'hidden';
  }

  handleDateFilterOpen = () => {
    this.setState({
      dateModalOpen: true,
    });
    document.body.style.overflow = 'hidden';
  }

  handleDateFilterClose = () => {
    this.setState({
      dateModalOpen: false,
    });
    document.body.style.overflow = '';
  }

  handleCinemaFilterClose = () => {
    this.setState({
      cinemaModalOpen: false,
    });
    document.body.style.overflow = '';
  }

  bodyOnClick = (dispatchCloseModal) => {
    if (!this.state.initialised) {
      document.documentElement.addEventListener('click', (event) => {
        const pathes = event.path || (event.composedPath && event.composedPath());
        if (!pathes.some(path => (path.classList
          ? path.classList.contains('react-purchase-content') || path.classList.contains('react-purchase-modal-container')
          : false),
        )) {
          dispatchCloseModal();
        }
      });
      this.setState({ initialised: true });
    }
  }

  render() {
    const { cinemaModalOpen, dateModalOpen } = this.state;
    const {
      cinemas, dispatchSelectCinema,
      selectedCinema, selectedWeek,
      dates, selectedDate,
      dispatchSelectDate,
      dispatchSelectView, selectedView,
      timeList, realTableData,
      currentTime, filteredMovies,
      activeModal, dispatchCloseModal,
      movies, active, brandClass,
      width, dispatchOpenModal, brand,
      schedule,
    } = this.props;

    this.bodyOnClick(dispatchCloseModal);

    return (
      <>
        {
          schedule
            ? (
              <React.Fragment>
                <div className="react-filter-mobile-view-selector-container">
                  <ViewSelector selectView={(view) => { dispatchSelectView(view); }} selectedView={selectedView} />
                </div>
                <div className={`react-filter-mobile-container${cinemaModalOpen || dateModalOpen ? ' none' : ''}`}>
                  {
                    brand === 0 && (cinemas !== null && cinemas.length !== 1)
                      ? (
                        <MobileCinemaFilter
                          onClick={this.handleCinemaFilterOpen}
                          selectedCinema={selectedCinema}
                          cinemas={cinemas}
                          brand={brand}
                          brandClass={brandClass}
                        />
                      ) : null
                  }
                  <MobileDateFilter
                    onClick={this.handleDateFilterOpen}
                    selectedDate={selectedDate}
                    dates={dates}
                    brandClass={brandClass}
                  />
                </div>
                <div className={`react-filter-mobile-title${cinemaModalOpen || dateModalOpen ? ' none' : ''}`}>
                  {`Összesen ${filteredMovies.length ? filteredMovies.length : 0} film`}
                </div>
                {
                  cinemaModalOpen
                  && (
                    <MobileCinemaFilterModal
                      modalOpen={cinemaModalOpen}
                      onClose={this.handleCinemaFilterClose}
                      cinemas={cinemas}
                      selectCinema={(cinema) => { dispatchSelectCinema(cinema); }}
                      selectedCinema={selectedCinema}
                      brandClass={brandClass}
                    />
                  )
                }
                {
                  dateModalOpen
                  && (
                    <MobileDateFilterModal
                      modalOpen={dateModalOpen}
                      onClose={this.handleDateFilterClose}
                      dates={dates}
                      selectDate={(date) => { dispatchSelectDate(date); }}
                      selectedWeek={selectedWeek}
                      selectedDate={selectedDate}
                      brandClass={brandClass}
                    />
                  )
                }
                {currentTime !== null ? (
                  <div className={`${cinemaModalOpen || dateModalOpen ? 'react-none' : ''}`}>
                    {
                      selectedView !== 'tile'
                        ? (
                          <MovieTable
                            timeList={timeList}
                            dateNowIndex={currentTime.dateNowIndex}
                            realTableData={realTableData}
                            hours={currentTime.hours}
                            minutes={currentTime.minutes}
                            selectedDate={selectedDate}
                            width={width}
                            onModalClick={(modal) => { dispatchOpenModal(modal); }}
                            activeModal={activeModal}
                            isVisible={cinemaModalOpen || dateModalOpen}
                            brandClass={brandClass}
                          />
                        )
                        : (
                          <div>
                            {
                              width <= 620
                                ? (
                                  <MobileFilmTiles
                                    filteredMovies={filteredMovies}
                                    movies={movies}
                                    active={active}
                                    hours={currentTime.hours}
                                    minutes={currentTime.minutes}
                                    selectedDate={selectedDate}
                                    selectedCinema={selectedCinema}
                                    brandClass={brandClass}
                                    brand={brand}
                                    activeModal={activeModal}
                                    dispatchOpenModal={(modal) => { dispatchOpenModal(modal); }}
                                  />
                                )
                                : (
                                  <FilmTiles
                                    width={width}
                                    filteredMovies={filteredMovies}
                                    openModal={(modal) => { dispatchOpenModal(modal); }}
                                    activeModal={activeModal}
                                    hours={currentTime.hours}
                                    minutes={currentTime.minutes}
                                    selectedDate={selectedDate}
                                    brandClass={brandClass}
                                    brand={brand}
                                  />
                                )
                            }
                          </div>
                        )
                    }
                  </div>
                ) : null}
              </React.Fragment>
            )
            : null
        }
      </>
    );
  }
}

const mapDispatchToProps = {
  dispatchSelectCinema: selectCinema,
  dispatchGetWeekDetails: getWeekDetails,
  dispatchSelectDate: selectDate,
  dispatchSelectView: selectView,
  dispatchGetCurrentTime: getCurrentTime,
  dispatchGetWeeksAndCinemas: getWeeksAndCinemas,
  dispatchCloseModal: closeModal,
  dispatchOpenModal: openModal,
  dispatchGetFestival: getFestival,
};

const mapStateToProps = store => ({
  cinemas: store.app.cinemas,
  dates: store.app.dates,
  selectedCinema: store.app.selectedCinema,
  selectedWeek: store.app.selectedWeek,
  selectedDate: store.app.selectedDate,
  selectedView: store.app.selectedView,
  timeList: store.app.timeList,
  realTableData: store.app.realTableData,
  currentTime: store.app.currentTime,
  filteredMovies: store.app.filteredMovies,
  movies: store.app.movies,
  active: store.app.active,
  activeModal: store.app.activeModal,
  brand: store.app.brand,
  brandClass: store.app.brandClass,
  schedule: store.app.schedule,
});

MobileAppFilter.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.shape({})),
  activeModal: PropTypes.shape({}).isRequired,
  width: PropTypes.number.isRequired,
  currentTime: PropTypes.shape({}),
  filteredMovies: PropTypes.arrayOf(PropTypes.shape({})),
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
  dispatchGetCurrentTime: PropTypes.func.isRequired,
  dispatchOpenModal: PropTypes.func.isRequired,
  dispatchGetFestival: PropTypes.func.isRequired,
  dispatchGetWeeksAndCinemas: PropTypes.func.isRequired,
  dispatchSelectCinema: PropTypes.func.isRequired,
  dispatchSelectDate: PropTypes.func.isRequired,
  dispatchSelectView: PropTypes.func.isRequired,
  dispatchCloseModal: PropTypes.func.isRequired,
  selectedCinema: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  brand: PropTypes.number,
  brandClass: PropTypes.string,
  selectedWeek: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  selectedView: PropTypes.string.isRequired,
  selectedDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  dates: PropTypes.arrayOf(PropTypes.shape({})),
  timeList: PropTypes.arrayOf(PropTypes.string).isRequired,
  realTableData: PropTypes.arrayOf(PropTypes.shape({})),
  movies: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  active: PropTypes.shape({
    movieId: PropTypes.number.isRequired,
    playtimeIndex: PropTypes.number.isRequired,
  }),
  festival: PropTypes.string.isRequired,
};

MobileAppFilter.defaultProps = {
  schedule: null,
  realTableData: null,
  brand: null,
  currentTime: null,
  filteredMovies: null,
  selectedWeek: null,
  dates: null,
  cinemas: null,
  active: null,
  brandClass: 'react-artmozi',
};

export default connect(mapStateToProps, mapDispatchToProps)(MobileAppFilter);
